import { Tab, Tabs } from '@mui/material'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import PersonIcon from '@mui/icons-material/Person'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import EmailIcon from '@mui/icons-material/Email'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee'
import { updateModal } from '../../store/common/common_action'
import { lrSearchModeAtom, searchLrDataAtom, selectLrAtom, showHeaderAtom } from '../common/jotaiState/lrSearchAtoms'
import { getBaseGSTInvoiceURL, mainTabIds, pcTabIds, UNIT_BILLED } from '../common/constants'
import { LrTrackCard } from '../lrSearch/lrTrackCard'
import { LrTrackCommonControls } from '../lrSearch/lrTrackControls'
import { IdAndImagePreview, ImagePreiewPopup, Item } from '../common/snippets'
import DropDown from '../common/dropDown'
import { AllPaymentList } from '../common/paymentsMode'
import Modal from '../common/modal'
import { STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { companySettingsAtom } from '../common/jotaiState/commonStateAtoms'
const tablabels = ['LR DETAILS', 'LR TRACKING']

export const LrTrackingPopupUI = (props) => {
  const { controlData } = props
  const dispatch = useDispatch()
  const common = useSelector((state) => state?.common)
  const { lrStatus, loginData, roleRights } = common
  const [companySettings] = useAtom(companySettingsAtom)
  const { UseToPayAsCOD = 0,DefaultCurrencyID=0 } = companySettings
  const [searchParams, setSearchParams] = useSearchParams()
  const [tabNumber, setTabNumber] = useState(searchParams.get('tab') || 0)
  const [csTab, setCsTab] = useState(searchParams.get('cstab') || 0)
  const [pcTabValue, setPcTabValue] = useState(parseInt(csTab))
  const [lrTabValue, setLrTabValue] = useState(parseInt(tabNumber))
  const [showHeader, setShowHeader] = useAtom(showHeaderAtom)
  const [mode, SetMode] = useAtom(lrSearchModeAtom)
  const [selectLr, setSelectLr] = useAtom(selectLrAtom)
  const [idDetailsPreview, setIdDetailPreview] = useState(false)
  const [idDetailsProps, setIdDetailsProps] = useState(false)
  const [personImagePreview, setPersonImagePreview] = useState(false)
  const [personImageProps, setPersonImageProps] = useState(false)
  const [searchLrData, setSearchLrData] = useAtom(searchLrDataAtom)
  const [bookingInvLink, setBookingInvLink] = useState('')
  const [deliveryInvLink, setDeliveryInvLink] = useState('')
  const consignmentDetails = lrStatus?.Data?.Table
  const lrInfo = consignmentDetails?.[0]
  const LrTrackData = lrStatus?.Data?.Table1
  const firstStatus = LrTrackData ? LrTrackData?.[0] : false
  const lastStatus = LrTrackData ? LrTrackData[LrTrackData.length - 1] : false
  const showSenIdDrop = lrInfo?.SenderIDProof || lrInfo?.SenderIDProofNo || firstStatus?.IDProofImageURL || false
  const showsenImage = firstStatus?.SenderImageURL || false
  const showRecIdDrop = lrInfo?.ReceiverIDProof || lrInfo?.ReceiverIDProofNo || lastStatus?.IDProofImageURL || false
  const showRecImage = lastStatus?.SenderImageURL || false
  let { EWayBillNo = '', ExemptedGoods = '' } = lrInfo || {}
  if (EWayBillNo) {
    EWayBillNo = EWayBillNo.split('~')
    EWayBillNo = EWayBillNo[0]
    EWayBillNo = EWayBillNo.split(',')
    EWayBillNo = EWayBillNo.join(`,\n`)
  }
  let ShowLR = 0
  let consignmentType, mopName, description, totalUnits, unitSum, goodsValue
  let actualWeight, chargedWeight, allRate, allFreights, totalFreight
  consignmentType = mopName = description = totalUnits = goodsValue = actualWeight = chargedWeight = allRate = allFreights = ''
  let allSize = ''
  let allWeightVolume = ''
  unitSum = 0
  totalFreight = 0
  consignmentDetails?.map((el, index, { length }) => {
    unitSum += parseInt(el.Quantity)
    totalFreight += parseInt(el.Freight)
    if (index + 1 === length) {
      consignmentType += el.SubType
      mopName += el.MOPName
      description += el.Description
      totalUnits += el.Quantity
      goodsValue += el.GoodsValue
      actualWeight += el.ActualWeight + 'KG'
      chargedWeight += el.ChargedWeight + 'KG'
      allRate += el.Rate + (el.BillingUnit === UNIT_BILLED ? ' Per UNIT' : ' Per KG')
      allFreights += el.Freight
      allSize += `${el.Length || 0} X ${el.Width || 0} X ${el.Height || 0}`
      allWeightVolume += el.VolumeWeight || 0
      ShowLR = el.LRNO
    } else {
      consignmentType += el.SubType + ', '
      mopName += el.MOPName + ', '
      description += el.Description + ','
      totalUnits += el.Quantity + '+'
      goodsValue += el.GoodsValue + ', '
      actualWeight += el.ActualWeight + 'KG' + ', '
      chargedWeight += el.ChargedWeight + 'KG' + ', '
      allRate += el.Rate + (el.BillingUnit === UNIT_BILLED ? ' Per UNIT' : ' Per KG') + ', '
      allFreights += el.Freight + ','
      allSize += `${el.Length || 0} X ${el.Width || 0} X ${el.Height || 0}` + ', '
      allWeightVolume += (el.VolumeWeight || 0) + ' ,'
    }
  })

  useEffect(() => {
    if (lrInfo?.BookingID !== undefined || lrInfo?.BookingID !== null) {
      setBookingInvLink(getBaseGSTInvoiceURL(lrInfo?.BookingID, 'B', lrInfo?.BookingCompanyID))
      setDeliveryInvLink(getBaseGSTInvoiceURL(lrInfo?.BookingID, 'D', lrInfo?.DeliveryCompanyID))
    }
  }, [lrInfo])

  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab, pcTab) => {
    params.tab = lrTab
    params.cstab = pcTab
    setSearchParams(params)
  }
  const modeClose = () => dispatch(updateModal())
  const handleCancel = () => {
    //setApiCall(false)
    setShowHeader(true)
    setSearchLrData([])
    dispatch(updateModal())
    SetMode(1)
  }
  const setPopupIdDetails = (isSender = true) => {
    let data = {
      updateModal: setIdDetailPreview,
    }
    if (isSender) {
      data.imgUrl = firstStatus?.IDProofImageURL
      data.idValue = lrInfo?.SenderIDProofNo
      data.idTypeValue = lrInfo?.SenderIDProof
    } else {
      data.imgUrl = lastStatus?.IDProofImageURL
      data.idValue = lrInfo?.ReceiverIDProofNo
      data.idTypeValue = lrInfo?.ReceiverIDProof
    }
    setIdDetailsProps(data)
    setIdDetailPreview(true)
  }
  const showImagePreviewPopup = (isSender = true) => {
    let data = {
      updateModal: setPersonImagePreview,
      data: { hideControl: true },
    }
    if (isSender) {
      data.data.src = firstStatus.SenderImageURL
    } else {
      data.data.src = lastStatus.SenderImageURL
    }
    setPersonImageProps(data)
    setPersonImagePreview(true)
  }

  return (
    <Modal
      headTxt={tablabels[lrTabValue]}
      headText2={'LR Number: ' + selectLr?.LRNo}
      width={'25%'}
      height={'100%'}
      updateModal={modeClose}
      modalClass="model--container-right"
      onCloseCallback={handleCancel}
    >
      <>
        <Tabs
          sx={{ borderBottom: 1, borderColor: 'divider', background: '#fff' }}
          value={lrTabValue}
          onChange={(e, newValue) => {
            goToTabs(newValue, pcTabValue)
            setLrTabValue(parseInt(newValue))
          }}
          className="lrtrack-tabs"
          aria-label="tabs for lr details and lr tracking"
        >
          <Tab label={tablabels[0]} sx={{ width: '50%' }} aria-label="basic tabs example" {...mainTabIds(0)} />
          <Tab label={tablabels[1]} sx={{ width: '50%' }} aria-label="basic tabs example" {...mainTabIds(1)} />
        </Tabs>
        <div
          role="tabpanel"
          hidden={lrTabValue !== 0}
          id={`main-tabpanel-0`}
          aria-labelledby={`main-tab-0`}
          className="tab-main-1 detailed-tabs"
          style={{ height: 'calc(100% - 260px)', overflowX: 'auto' }}
        >
          <div className="tablayout tab-secondary">
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={pcTabValue}
              onChange={(e, newValue) => {
                goToTabs(lrTabValue, newValue)
                setPcTabValue(parseInt(newValue))
              }}
              className="lrtrack-tabs"
              aria-label="tabs for payee and consignment details"
            >
              <Tab label="PAYEE DETAILS" sx={{ width: '50%' }} aria-label="basic tabs example" {...pcTabIds(0)} />
              <Tab label="CONSIGNMENT DETAILS" sx={{ width: '50%' }} aria-label="basic tabs example" {...pcTabIds(1)} />
            </Tabs>
          </div>
          <div
            role="tabpanel"
            hidden={pcTabValue !== 0}
            id={`pc-tabpanel-0`}
            aria-labelledby={`pc-tab-0`}
            className="tab-pc-1 detailed-tabs tab1-view"
          >
            <div className="source-details">
              <div className="heading-tab">Source: {lrInfo?.FromCity}</div>
              <div className="tab-details">Branch: {lrInfo?.BkgBranchName}</div>
              <div className="tab-details">
                <PersonIcon />
                Sender Name:{lrInfo?.Sender}
              </div>
              <div className="tab-details">
                <LocalPhoneIcon />
                Sender No:{lrInfo?.SenderMobileNo}
              </div>
              {lrInfo?.SenderEmailID != '' && (
                <div className="tab-details">
                  <EmailIcon />
                  Sender Email: {lrInfo?.SenderEmailID}
                </div>
              )}

              {lrInfo?.SenderGSTN != '' && (
                <div className="tab-details">
                  <CurrencyRupeeIcon />
                  Sender GSTN:{lrInfo?.SenderGSTN}
                </div>
              )}
              {showSenIdDrop && (
                <Item sx={{ width: '100%' }}>
                  <DropDown
                    disabled={false}
                    type="file"
                    //defaultvalue={lrInfo?.SenderIDProof + `${lrInfo?.SenderIDProofNo ?}`}
                    defaultvalue={`${lrInfo?.SenderIDProof || 'No ID Type'} | ${lrInfo?.SenderIDProofNo || 'No Id Number'}`}
                    data={[]}
                    actnTxt={`Show`}
                    showActn={true}
                    onClick={setPopupIdDetails}
                  />
                </Item>
              )}
              {showsenImage && (
                <Item sx={{ width: '100%' }}>
                  <p
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      maxWidth: '800px',
                      fontSize: '13px',
                      color: 'black',
                      margin: '0px',
                    }}
                  >
                    <span>Sender Image:</span>
                    <img
                      src={firstStatus.SenderImageURL}
                      width="100px"
                      height="66px"
                      style={{
                        height: '50px',
                        width: '50px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        margin: '0px 10px',
                      }}
                      border="0"
                    />

                    <a
                      href=""
                      id="idImageViewLink"
                      // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                      className="thumbnail blue-color-txt"
                      onClick={(e) => {
                        e.preventDefault()
                        showImagePreviewPopup(true)
                      }}
                    >
                      Show
                      <span>
                        <img className={'right'} src={firstStatus.SenderImageURL} />
                      </span>
                    </a>
                  </p>
                </Item>
              )}
            </div>
            <div className="destination-details">
              <div className="heading-tab">Destination: {lrInfo?.ToCity}</div>
              <div className="tab-details">Branch: {lrInfo?.DestinationBranch}</div>
              <div className="tab-details">
                <PersonIcon />
                Receiver Name: {lrInfo?.RecName}
              </div>
              <div className="tab-details">
                <LocalPhoneIcon /> Receiver No: {lrInfo?.RecMobileNo}
              </div>
              {lrInfo?.ReceiverEmailID != '' && (
                <div className="tab-details">
                  <EmailIcon />
                  Receiver Email: {lrInfo?.ReceiverEmailID}
                </div>
              )}
              {lrInfo?.ReceiverGSTN != '' && (
                <div className="tab-details">
                  <CurrencyRupeeIcon />
                  Receiver GSTN:{lrInfo?.ReceiverGSTN}
                </div>
              )}

              {lastStatus.TYPE === 'F' && showRecIdDrop && (
                <Item sx={{ width: '100%' }}>
                  <DropDown
                    disabled={false}
                    type="file"
                    defaultvalue={`${lrInfo?.ReceiverIDProof || 'No ID Type'} | ${lrInfo?.ReceiverIDProofNo || 'No Id Number'}`}
                    data={[]}
                    actnTxt={`Show`}
                    showActn={true}
                    onClick={() => {
                      setPopupIdDetails(false)
                    }}
                  />
                </Item>
              )}
              {lastStatus.TYPE === 'F' && showRecImage && (
                <Item sx={{ width: '100%' }}>
                  <p
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      maxWidth: '800px',
                      fontSize: '13px',
                      color: 'black',
                      margin: '0px',
                    }}
                  >
                    <span>Receiver Image:</span>
                    <img
                      src={lastStatus.SenderImageURL}
                      width="100px"
                      height="66px"
                      style={{
                        height: '50px',
                        width: '50px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        margin: '0px 10px',
                      }}
                      border="0"
                    />
                    <a
                      href=""
                      id="idImageViewLink"
                      // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                      className="thumbnail blue-color-txt"
                      onClick={(e) => {
                        e.preventDefault()
                        showImagePreviewPopup(false)
                      }}
                    >
                      Show
                      <span>
                        <img className={'right'} src={lastStatus.SenderImageURL} />
                      </span>
                    </a>
                  </p>
                </Item>
              )}
            </div>
            {lrInfo?.IsBookingInvoice === 1 && (
              <div className="booking-gst-inv-details">
                <div style={{fontWeight:'bold'}}>{`Booking GST Invoice: ${lrInfo?.BookingInvoiceNo}`}</div>
                <div>
                  <a href={bookingInvLink} style={{ color: 'blue', textDecoration: 'underline' }} target="_blank">
                    Invoice Link
                  </a>
                </div>
              </div>
            )}
            {lrInfo?.IsDeliveryInvoice === 1 && (
              <div className="booking-gst-inv-details">
                <div style={{fontWeight:'bold'}}>{`Delivery GST Invoice: ${lrInfo?.DeliveryInvoiceNo}`}</div>
                <div>
                  <a href={deliveryInvLink} style={{ color: 'blue', textDecoration: 'underline' }} target="_blank">
                    Invoice Link
                  </a>
                </div>
              </div>
            )}
            <div className="bottom-container" style={{ display: 'none' }}>
              <div className="bottom-button-container">
                <div className="outlined-bottom-button flex-center-all">Booking Cancel</div>
                <div className="outlined-bottom-button flex-center-all">Delivery Cancel</div>
                <div className="outlined-bottom-button flex-center-all">Booking Reprint</div>
                <div className="outlined-bottom-button flex-center-all">Delivery Reprint</div>
              </div>
            </div>
          </div>
          <div
            role="tabpanel"
            hidden={pcTabValue !== 1}
            id={`pc-tabpanel-1`}
            aria-labelledby={`pc-tab-1`}
            className="tab-pc-2 detailed-tabs tab2-view"
          >
            <div className="tab2-container">
              <div className="cnsn-row misty-dark-bg">
                <div className="box-padding left">Payment Type</div>
                {/* <div className="box-padding right">{AllPaymentList[+lrInfo?.PaymentType || 0]}</div> */}
                <div className="box-padding right">
                  {(() => {
                    let paymentIndex = +lrInfo?.PaymentType || 0;
                    let payment = AllPaymentList[paymentIndex];

                    if (UseToPayAsCOD === 1) {
                      if (paymentIndex === 2) payment = "COD";
                      if (paymentIndex === 7) payment = "COD_MANUAL";
                    }

                    return payment;
                  })()}
                </div>
              </div>
              <div className="cnsn-row misty-bg">
                <div className="box-padding left">Invoice No</div>
                <div className="box-padding right">{lrInfo?.PartyBillNo} </div>
              </div>
              <div className="cnsn-row misty-dark-bg">
                <div className="box-padding left">Invoice Amount</div>
                <div className="box-padding right">{lrInfo?.BillAmount}</div>
              </div>
              <div className="cnsn-row misty-bg">
                <div className="box-padding left">Consignment Type</div>
                <div className="box-padding right">{consignmentType} </div>
              </div>
              <div className="cnsn-row misty-dark-bg">
                <div className="box-padding left">Method of Packing</div>
                <div className="box-padding right">{mopName}</div>
              </div>
              <div className="cnsn-row misty-bg">
                <div className="box-padding left">Description</div>
                <div className="box-padding right">{description}</div>
              </div>
              <div className="cnsn-row misty-dark-bg">
                <div className="box-padding left">Cartage Remark</div>
                <div className="box-padding right">{lrInfo?.CartageRemarks} </div>
              </div>
              <div className="cnsn-row misty-dark-bg">
                <div className="box-padding left">Total Units</div>
                <div className="box-padding right">
                  {totalUnits}={unitSum}
                </div>
              </div>
              <div className="cnsn-row misty-bg">
                <div className="box-padding left">Goods Value</div>
                <div className="box-padding right">
                  {goodsValue == 0 && loginData.intCompanyID === STA_COMPANY_ID ? 'As Per Carrier Act' : goodsValue}
                </div>
              </div>
              {ExemptedGoods || EWayBillNo ? (
                <div className="cnsn-row misty-dark-bg">
                  <div className="box-padding left"> E-way Bill No</div>
                  <div className="box-padding right" style={{ whiteSpace: 'pre' }}>
                    {EWayBillNo || ExemptedGoods}
                  </div>
                </div>
              ) : (
                ''
              )}
              <div className="cnsn-row misty-bg">
                <div className="box-padding left">Actual Weight</div>
                <div className="box-padding right">{actualWeight}</div>
              </div>
              {loginData.intCompanyID === STA_COMPANY_ID ? (
                <>
                  <div className="cnsn-row misty-dark-bg">
                    <div className="box-padding left">CFT Weight</div>
                    <div className="box-padding right">{allWeightVolume}</div>
                  </div>
                  <div className="cnsn-row misty-bg">
                    <div className="box-padding left">CFT Size</div>
                    <div className="box-padding right" style={{ whiteSpace: 'normal' }}>
                      {allSize}
                    </div>
                  </div>
                </>
              ) : (
                ''
              )}
              <div className="cnsn-row misty-dark-bg">
                <div className="box-padding left">Charged Weight</div>
                <div className="box-padding right">{chargedWeight}</div>
              </div>

              <div className="cnsn-row misty-bg">
                <div className="box-padding left">Rate</div>
                <div className="box-padding right">{allRate}</div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">Freight</div>
                <div className="box-padding right">
                  {allFreights}={totalFreight}
                </div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">Pickup Cartage</div>
                <div className="box-padding right">{lrInfo?.PickupCartage} </div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">Misc Cartage</div>
                <div className="box-padding right">{lrInfo?.CommCartage} </div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">Delivery Cartage</div>
                <div className="box-padding right">{lrInfo?.DeliveryCartage}</div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">{loginData?.intCompanyID === STA_COMPANY_ID? "Hamali and ToPay Charge": "Hamali and Operator Hamali"}</div>
                <div className="box-padding right">
                  {lrInfo?.HamaliCharges}+{lrInfo?.OperatorHamali}={parseInt(lrInfo?.HamaliCharges) + parseInt(lrInfo?.OperatorHamali)}
                </div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">{DefaultCurrencyID ===2?'Insurance Charge':'Valuation Charge'}</div>
                <div className="box-padding right">{lrInfo?.Valuation}</div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">Document Charge</div>
                <div className="box-padding right">{lrInfo?.DocumentCharges}</div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">Other Charges</div>
                <div className="box-padding right">{lrInfo?.OtherCharge}</div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">GST</div>
                <div className="box-padding right">{lrInfo?.ServiceTax}</div>
              </div>
              <div className="cnsn-row">
                <div className="box-padding left">Total Amount</div>
                <div className="box-padding right">{lrInfo?.NetAmount}</div>
              </div>
            </div>
            <div className="bottom-container" style={{ display: 'none' }}>
              <div className="search-button main-button flex-center-all">search new lr</div>
            </div>
          </div>
        </div>
        <div
          role="tabpanel"
          hidden={lrTabValue !== 1}
          id={`main-tabpanel-1`}
          aria-labelledby={`main-tab-1`}
          className="tab-main-2 details-container"
          style={{ height: 'calc(100% - 260px)', overflowX: 'auto' }}
        >
          <div>
            {LrTrackData?.map((Item, index, { length }) => {
              return <LrTrackCard data={Item} key={'lrTrackCard' + index} lastIndex={length - 1 === index} />
            })}
          </div>
        </div>
        <div className="lrt-card" style={{ background: '#fff', borderTop: '2px solid #ddd' }}>
          <LrTrackCommonControls
            lrInfo={lrInfo}
            lrStatInfo={LrTrackData}
            loginData={loginData}
            data={controlData}
            roleRights={roleRights}
          />
        </div>
        {idDetailsPreview && <IdAndImagePreview {...idDetailsProps} />}
        {personImagePreview && <ImagePreiewPopup {...personImageProps} />}
      </>
    </Modal>
  )
}
